import type { SchemaChatResolver_GetChats } from 'cpool-tables/backend-resolvers';

type ChatNameFields = Pick<SchemaChatResolver_GetChats[number], 'applicantName' | 'customerIdentity' | 'partnerName'>;

export const deriveChatDisplayName = (chat: ChatNameFields): string =>
    chat.applicantName ?? chat.partnerName ?? chat.customerIdentity;
